import axios from 'axios';
import { BACKEND_ENDPOINT } from '../configs';

axios.defaults.baseURL = BACKEND_ENDPOINT;
axios.defaults.headers.common.Authorization = `Bearer ${process.env.REACT_APP_API_ACCESS_TOKEN}`;
axios.defaults.headers.common['Auth-User-Role'] = 'doctor';
axios.defaults.headers.common['Auth-User-Access-Token'] = '';
